<template>
	<div class="con">
		
		<div class="pay-title">
			<div>{{cardId.name}}</div>
			<div>
				<div @click="showPopup">{{currentDate.getFullYear()}}</div>
				<van-popup v-model="show" position="top" custom-style="height: 20%;">
					<van-datetime-picker :max-date="maxDate" type="year" v-model="currentDate" @cancel="onClose()" @confirm="confirmFn(currentDate)" />
				</van-popup>
			</div>
		</div>
		<div class="head">
			<van-tabs v-model="headActive" color="#27bec4" @change="headBtn">
				<van-tab title="待缴费"></van-tab>
				<van-tab title="已缴费"></van-tab>
			</van-tabs>
		</div>
		<div class="list">
			<div v-for="(item, index) in list">
				<div class="list-con">
					<div class="list-con-top" @click="showBtn(index)">
						<div>
							<div>{{item.KSMC}}</div>
							<div class="serial-number">挂号序号：{{item.GHXH}}</div>
							<div class="time-disp">
								<van-icon name="underway-o" color="#27BEC4" />
								<div class="time-text">{{item.KSSJ}}</div>
							</div>

						</div>
						<div class="price">
							<div><span>￥</span>{{item.totalPrice}}</div>
							<van-icon name="arrow" color="#ccc" v-if="!item.showState" />
							<van-icon name="arrow-down" color="#ccc" v-else />
						</div>
					</div>
					<div class="paybtn" :class="[item.costShowState != false ? 'paybtnCCC':'']" @click="paycostBtn(item.totalPrice, item.GHXH, index)">缴费</div>
				</div>

				<div class="show-box" v-show="item.showState">
					<div class="show-disp" v-for="d in item.dateil">
						<div class="medicines">
							<div>{{d.FYMC}}</div>
							<div>医生：{{d.YGXM}}</div>
							<div class="time-disp">
								<van-icon name="underway-o" color="#27BEC4" />
								<div class="time-text">{{d.KSSJ}}</div>
							</div>
						</div>
						<div class="show-disp-right">
							<div class="box-num">x{{d.XMSL}}</div>
							<div class="box-unit-price" v-if="d.MFBZ == 0"><span>￥</span>{{d.XMDJ}}</div>
							<div class="box-unit-price" v-else>免费</div>
						</div>
					</div>
				</div>
			</div>

			<div class="noImg" v-if="noImgShow == true">
				<img src="../assets/404.gif" />
				<div class="no-text">无缴费清单~~</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: 'payCost',
		data() {
			return {
				msg: '缴费',
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				cardId: JSON.parse(localStorage.getItem('cardUserInfo')),
				list: [],
				paytotal: 0,
				noImgShow: false,
				timer: null,
				show: false,
				currentDate: new Date(),
				maxDate: new Date(),
				headActive: 0,
			}
		},
		methods: {
			showPopup() {
				this.show = true;
			},

			onClose() {
				this.show = false;
			},
			confirmFn(e) {
				this.currentDate = e;
				this.show = false;
				this.GetMoneyByYzxh()
			},

			//支付
			//payType 1-门诊 2-住院
			paycostBtn(e, ghxh, index) {
				let that = this;
				this.list[index].costShowState = true;
				clearTimeout(that.timer);
				that.timer = setTimeout(function() {
					that.$toast('请稍等！');
					that.$Axios.Post(that.$Axios.wxUrl + '/wxpay/payOrder?openid=' + that.userInfo.openid + '&name=' + that.cardId.name + '&sfzh=' + that.cardId.sfzh + '&brid=' + that.cardId.brid + '&year=' + that
						.currentDate.getFullYear() + '&zjje=' + e + '&wxje=' + e + '&ghxh=' + ghxh + '&payType=1', null).then(res => {
						console.log(res)
						if(res.data.code == 0){
							const pay_params = res.data.data;
							if (typeof WeixinJSBridge === "undefined") {
								that.$toast('请在手机操作！');
								if (document.addEventListener) {
									document.addEventListener('WeixinJSBridgeReady', that.onBridgeReady, false);
								} else if (document.attachEvent) {
									document.attachEvent('WeixinJSBridgeReady', that.onBridgeReady);
									document.attachEvent('onWeixinJSBridgeReady', that.onBridgeReady);
								}
							} else {
								that.onBridgeReady(pay_params);
							}
						}else{
							that.$toast(res.data.msg);
							this.list[index].costShowState = false;
						}
						
					}).catch(err => {
						console.log(err)
						this.list[index].costShowState = false;
					})
					
				}, 300)
			},
			onBridgeReady(params) {
				let that = this
				WeixinJSBridge.invoke(
					'getBrandWCPayRequest', {
						"appId": params.appId, //公众号名称，由商户传入
						"timeStamp": params.timeStamp, //支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
						"nonceStr": params.nonceStr, //支付签名随机串，不长于 32 位
						"package": params.package, //统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
						"signType": 'MD5', //签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
						"paySign": params.paySign, //支付签名
					},
					function(res) {
						if(res.err_msg == "get_brand_wcpay_request:ok" ){
						  // 使用以上方式判断前端返回,微信团队郑重提示：
								//res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
								that.$toast('支付成功')
								that.$router.push('/paymentRecordsList');
						  } else{
								that.$toast('支付失败')
						  }
						  setTimeout(function() {
							  that.$router.go(0);
						  }, 300);
						
						that.list[index].costShowState = false;
					});
			},
			/**
			 * 未支付列表
			 * type：1-未缴费 2-已缴费
			 * year：yyyy
			 * */
			GetMoneyByYzxh() {
				this.$Axios.Get('/outpatient/getOutFy?brid=' + this.cardId.brid + '&type=1&year=' + this.currentDate.getFullYear(),
					null).then(res => {
					console.log(res)
					if (res.code == 0) {
						let dataList = res.msg;
						if (dataList.length > 0) {
							this.noImgShow = false;

							let newArr = [].concat(dataList);

							for (let i = 0; i < newArr.length; i++) {

								for (let j = i + 1; j < newArr.length;) {
									if (newArr[i].GHXH == newArr[j].GHXH) {
										newArr.splice(j, 1)
									} else {
										j++;
									}
								}
							}
							let totalNumP = 0;
							for (let i = 0; i < newArr.length; i++) {
								let newA = [];
								let total = 0;
								for (let j = 0; j < dataList.length; j++) {
									if (newArr[i].GHXH == dataList[j].GHXH) {
										newA.push(dataList[j])
										if (dataList[j].MFBZ == 0) { //不免费
											total += Number(dataList[j].ZJJE)
										}

									}
								}

								newArr[i].dateil = newA
								newArr[i].totalPrice = total.toFixed(2);
								newArr[i].showState = false;
								newArr[i].costShowState = false;//缴费按钮样式

								totalNumP += total.toFixed(2);

							}
							this.paytotal = totalNumP; //支付总金额
							this.list = newArr;
						} else {
							this.list = []
							this.noImgShow = true;
						}

					} else {
						this.noImgShow = true;
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//显示隐藏详情
			showBtn(e) {
				let listData = this.list;

				listData[e].showState = !listData[e].showState;
				this.list = listData;
			},
			//顶部导航
			headBtn(e) {
				if(e == 1){
					this.$router.replace({
						path: '/paymentRecordsList',
						query: {
							type: 1
						}
					})
				}
			}
		},
		mounted() {
			this.GetMoneyByYzxh();
		},
		created() {},
		
	}
</script>

<style scoped>
	.con {
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		width: 100%;
		height: 100%;
	}

	.pay-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px 30px;
		background: #27BEC4;
		color: #fff;
		font-size: 15px;
	}

	.list {
		flex: 1;
		overflow-y: auto;
	}

	.list-con {
		padding: 10px 20px;
		margin: 10px auto 0;
		font-size: 15px;
		border: 1px solid #ccc;
		border-radius: 10px;
		width: 80%;
		background-color: #fff;
	}

	.list-con-top {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.time-disp {
		display: flex;
		align-items: center;
		margin-top: 5px;
		color: #999;
	}

	.time-text {
		margin-left: 10px;
	}

	.price {
		display: flex;
		align-items: center;
		color: #FF0000;
		font-size: 18px;
		font-weight: 700;
	}

	.price span {
		font-weight: 500;
		font-size: 12px;
	}

	.total {
		display: flex;
		font-size: 15px;
	}

	.total div {
		padding: 20px 0;
		width: 50%;
		text-align: center;
	}

	.combined {
		background-color: #fff;
	}

	.combined span {
		color: #FF0000;
		font-size: 18px;
	}

	.pay-btn {
		background-color: #27BEC4;
		color: #fff;
	}

	.noImg {
		margin-top: 10vh;
		text-align: center;
	}

	.no-text {
		margin-top: 10px;
		color: #27BEC4;
		font-size: 16px;

	}

	.serial-number {
		margin: 5px 0;
		font-size: 12px;
		color: #999;
	}

	.show-box {
		padding: 10px;
		margin: 0 auto;
		width: 80%;
		background-color: #fff;
	}

	.show-disp {
		display: flex;
		justify-content: space-between;
		margin: 10px 0;
	}

	.medicines {
		width: 75%;
		color: #666;
		font-size: 14px;
	}

	.show-disp-right {
		text-align: end;
		width: 20%;
	}

	.box-num {
		font-size: 12px;
	}

	.box-unit-price {
		font-size: 14px;
		color: #FF0000;
		font-weight: 700;
	}

	.box-unit-price span {
		font-weight: 500;
		font-size: 12px;
	}

	.paybtn {
		display: inline-block;
		margin-top: 5px;
		padding: 5px 10px;
		font-size: 14px;
		color: #fff;
		border-radius: 15px;
		background-color: #27BEC4;
	}
	.paybtnCCC{
		background-color: #ccc;
	}
</style>
